import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { Observable } from 'rxjs';
import { UsersService } from './users.service';
import { map } from 'rxjs/operators';



@Injectable()
export class RoleGuard implements CanActivate {

  returnUrl: string = "";

  constructor(private _userService: UsersService) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean {

    this.returnUrl = route.pathFromRoot
      .map(v => v.url.map(segment => segment.toString()).join('/'))
      .join('');


    console.log('Checking authorization');
    return this._userService.hasManagerRoles().pipe(
      map(authorized => {

        console.log('Checking care manager authorization');
        if (!authorized) {
          console.log('Not authorized to change');
          window.location.href = "profile/error/notauthorized";

          return false
        }

        return true;

      })
    );

  }
}
